export const KEYS = {
  TAB: 'Tab',
  ENTER: 'Enter',
  NUMPAD_ENTER: 'NumpadEnter',
  ESC: 'Escape',
  SPACE: 'Space',
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown',
  SHIFT_LEFT: 'ShiftLeft',
  SHIFT_RIGHT: 'ShiftRight',
  CTRL_LEFT: 'ControlLeft',
  CTRL_RIGHT: 'ControlRight',
  ALT_LEFT: 'AltLeft',
  ALT_RIGHT: 'AltRight',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  HOME: 'Home',
  END: 'End',
  BACKSPACE: 'Backspace',
  DELETE: 'Delete'
};

export const isControlKey = (event: KeyboardEvent) => {
  switch (event.code) {
    case KEYS.SHIFT_LEFT:
    case KEYS.SHIFT_RIGHT:
    case KEYS.CTRL_LEFT:
    case KEYS.CTRL_RIGHT:
    case KEYS.ALT_LEFT:
    case KEYS.ALT_RIGHT:
      return true;
    default:
      return event.metaKey || event.ctrlKey;
  }
};

export const isFunctionKey = (event: KeyboardEvent) => {
  return /\bF([1-9]|1[0-2])\b/i.test(event.code);
};

export const isControlOrFunctionKey = (event: KeyboardEvent) => {
  return isControlKey(event) || isFunctionKey(event);
};

export const isSimpleClick = (event: MouseEvent) => {
  return event.button === 0 && !event.ctrlKey;
};

export const preventDefault = (event: Event) => {
  event.preventDefault();
};

export const preventDefaultForCurrentTarget = (event: MouseEvent) => {
  if (event.currentTarget === event.target) {
    event.preventDefault();
  }
};
